var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('ul',_vm._l((_vm.children),function(child){return _c('li',{key:child},[_vm._t(child,[_c('div',[_vm._v(_vm._s(child))])])],2)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }